/**
 * Asset: Multi-currency config
 * ------------------------------------------------------------------------------
 * Configuration file used in `currency.js` handler.
 * - Currencies defined here will be used in the Forex API arguments.
 * - All properties are required.
 */
window.Frame = window.Frame || {};
window.Frame.MultiCurrency = {
  SupportedCurrencies: [
    {
      currencyCode: 'ARS',
      currencyName: 'Argentine Peso',
      currencySymbol: 'ARS',
      currencyLocale: 'es-GB',
    },
    {
      currencyCode: 'AUD',
      currencyName: 'Australian Dollar',
      currencySymbol: 'AU$',
      currencyLocale: 'en-AU',
    },
    {
      currencyCode: 'BGN',
      currencyName: 'Bulgarian Lev',
      currencySymbol: 'Лв.',
      currencyLocale: 'en-BG',
    },
    {
      currencyCode: 'BOB',
      currencyName: 'Bolivian boliviano',
      currencySymbol: 'Bs',
      currencyLocale: 'es-BO',
    },
    {
      currencyCode: 'BRL',
      currencyName: 'Brazilian Real',
      currencySymbol: 'R$',
      currencyLocale: 'en-BR',
    },
    {
      currencyCode: 'CAD',
      currencyName: 'Canadian Dollar',
      currencySymbol: '$',
      currencyLocale: 'en-CA',
    },
    {
      currencyCode: 'CHF',
      currencyName: 'Swiss Franc',
      currencySymbol: 'CHF',
      currencyLocale: 'en-CH',
    },
    {
      currencyCode: 'CLP',
      currencyName: 'Chilean Peso',
      currencySymbol: 'CLP$',
      currencyLocale: 'es-CL',
    },
    {
      currencyCode: 'CNY',
      currencyName: 'Renminbi',
      currencySymbol: '¥',
      currencyLocale: 'en-CN',
    },
    {
      currencyCode: 'COP',
      currencyName: 'Colombian Peso',
      currencySymbol: 'COL$',
      currencyLocale: 'es-CO',
    },
    {
      currencyCode: 'CRC',
      currencyName: 'Costa Rican Ćolon',
      currencySymbol: '‎₡',
      currencyLocale: 'en-CR',
    },
    {
      currencyCode: 'CUP',
      currencyName: 'Cuban Peso',
      currencySymbol: '$MN',
      currencyLocale: 'es-CU',
    },
    {
      currencyCode: 'CZK',
      currencyName: 'Czech koruna',
      currencySymbol: 'Kč',
      currencyLocale: 'en-CZ',
    },
    {
      currencyCode: 'DKK',
      currencyName: 'Danish Krone',
      currencySymbol: 'kr',
      currencyLocale: 'en-DK',
    },
    {
      currencyCode: 'EUR',
      currencyName: 'Euro',
      currencySymbol: '€',
      currencyLocale: 'en-EU',
    },
    {
      currencyCode: 'GBP',
      currencyName: 'Pound Sterling',
      currencySymbol: '£',
      currencyLocale: 'en-GB',
    },
    {
      currencyCode: 'GTQ',
      currencyName: 'Guatemalan quetzal',
      currencySymbol: 'Q',
      currencyLocale: 'es-GT',
    },
    {
      currencyCode: 'HKD',
      currencyName: 'Hong Kong Dollar',
      currencySymbol: 'HK$',
      currencyLocale: 'en-HK',
    },
    {
      currencyCode: 'HNL',
      currencyName: 'Honduran lempira',
      currencySymbol: 'L',
      currencyLocale: 'es-HN',
    },
    {
      currencyCode: 'HRK',
      currencyName: 'Croation Kuna',
      currencySymbol: 'kn',
      currencyLocale: 'en-HR',
    },
    {
      currencyCode: 'ILS',
      currencyName: 'Israeli new shekel',
      currencySymbol: 'ILS',
      currencyLocale: 'en-IL',
    },
    {
      currencyCode: 'INR',
      currencyName: 'Indian Rupee',
      currencySymbol: '₹',
      currencyLocale: 'en-IN',
    },
    {
      currencyCode: 'JPY',
      currencyName: 'Japan Yen',
      currencySymbol: '¥',
      currencyLocale: 'en-JP',
    },
    {
      currencyCode: 'MKD',
      currencyName: 'Macedonian denar',
      currencySymbol: 'Ден',
      currencyLocale: 'en-MK',
    },
    {
      currencyCode: 'MXN',
      currencyName: 'Mexican Peso',
      currencySymbol: '$',
      currencyLocale: 'es-MX',
    },
    {
      currencyCode: 'NOK',
      currencyName: 'Norwegian Krone',
      currencySymbol: 'kr',
      currencyLocale: 'en-NO',
    },
    {
      currencyCode: 'NZD',
      currencyName: 'Pound Sterling',
      currencySymbol: 'NZ$',
      currencyLocale: 'en-NZ',
    },
    {
      currencyCode: 'PEN',
      currencyName: 'Peruvian Sol',
      currencySymbol: 'S/',
      currencyLocale: 'es-PE',
    },
    {
      currencyCode: 'PLN',
      currencyName: 'Polish Złoty',
      currencySymbol: 'zł',
      currencyLocale: 'en-PL',
    },
    {
      currencyCode: 'PYG',
      currencyName: 'Paraguayan guaraní',
      currencySymbol: '₲',
      currencyLocale: 'es-PY',
    },
    {
      currencyCode: 'RON',
      currencyName: 'Romanian new leu',
      currencySymbol: 'RON',
      currencyLocale: 'en-RO',
    },
    {
      currencyCode: 'SEK',
      currencyName: 'Swedish Krona',
      currencySymbol: 'kr',
      currencyLocale: 'en-SE',
    },
    {
      currencyCode: 'SGD',
      currencyName: 'Singapore Dollar',
      currencySymbol: 'S$',
      currencyLocale: 'en-SG',
    },
    {
      currencyCode: 'USD',
      currencyName: 'United States Dollar',
      currencySymbol: '$',
      currencyLocale: 'en-US',
    },
    {
      currencyCode: 'UYU',
      currencyName: 'Uruguayan peso',
      currencySymbol: '$U',
      currencyLocale: 'es-UY',
    },
    {
      currencyCode: 'VEF',
      currencyName: 'Venezuelan Bolivar',
      currencySymbol: 'Bs.',
      currencyLocale: 'es-VE',
    },
    {
      currencyCode: 'ZAR',
      currencyName: 'South African Rand',
      currencySymbol: 'R',
      currencyLocale: 'en-ZA',
    },
  ],
};
